module.exports = (__webpack_require__(7))(155);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/rxjs/observable/of.js from dll-reference vendor
// module id = 1199
// module chunks = 0